module.exports = __webpack_public_path__ + "static/media/Illus-Employee_1.fd94f8c6.png";